/**
 * HTML preview — renders the file content inside a sandboxed iframe.
 * Sandbox grants only same-origin (no scripts/forms/popups by default) to
 * keep risk low when previewing arbitrary local HTML.
 */

import { useT } from "@magic-md/i18n/react";

interface Props {
	content: string;
}

export function HtmlIframePreview({ content }: Props) {
	const t = useT("editor");
	return (
		<div className="h-full w-full bg-white rounded border border-border overflow-hidden">
			<iframe
				srcDoc={content}
				title={t("preview.html.title")}
				sandbox="allow-same-origin"
				className="w-full h-full border-0"
			/>
		</div>
	);
}
